import { useEffect, useState } from "react";
import { CompanyDetailsByCode } from "../../services/ReduxTookit/Slice/ProjectTermRedux";
import { useDispatch } from "react-redux";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import Nodata from "../../component/common-component/Nodata";

const PolicyManagementModel = () => {
  const dispatch = useDispatch();
  const [PrivacyData, setPrivacyData] = useState([]);
  const [PrivacyLoader, setPrivacyLoader] = useState(false);

  const getPrivacyData = async () => {
    setPrivacyLoader(true);
    dispatch(CompanyDetailsByCode())
      .then((response) => {
        if (response?.payload?.isValidate) {
          setPrivacyData(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setPrivacyData([]);
        }
      })
      .finally(() => {
        setPrivacyLoader(false);
      });
  };
  useEffect(() => {
    getPrivacyData();
  }, []);
  return (
    <>
      <div className="profile-common-title">
        {" "}
        <h3>General Privacy & Policy </h3>
      </div>
      <div className="profile-common">
        <div className="policy-main">
          {PrivacyLoader ? (
            <Loader type={LoaderType.FileContent} count={25} />
          ) : (
            <>
              {PrivacyData?.qdldevprivacypolicy?.length > 0 ? (
                <p
                  dangerouslySetInnerHTML={{
                    __html: PrivacyData?.qdldevprivacypolicy,
                  }}
                />
              ) : (
                <Nodata />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PolicyManagementModel;
